import React, { Component } from 'react';
import images from './images';
import './styles.css';

class WelcomeFooter extends Component {
	render() {
		return (
			<div className='welcome-footer'>
				<img className='logo-area-welcome' src={images['logoAreaWelcome']} alt={images['logoAreaWelcome']} />
				<img className='orange-rectangle' src={images['orangeRectangle']} alt={images['orangeRectangle']} />
			</div>
		);
	}
}


export default WelcomeFooter;
